module.exports = __webpack_public_path__ + "static/albums-hero-8695c8da3d31c9339e466b60b3a80757.jpg";